import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M20.845 9.72l-9.148 9.148a4.875 4.875 0 0 1-6.894-6.894l7.513-7.513a3 3 0 1 1 4.251 4.233L9.045 16.22a1.125 1.125 0 0 1-1.582-1.6l7.505-7.506a.75.75 0 0 0-1.06-1.06l-7.514 7.515a2.625 2.625 0 1 0 3.703 3.72l7.522-7.525a4.5 4.5 0 1 0-6.372-6.354l-7.505 7.503a6.375 6.375 0 1 0 9.016 9.016l9.147-9.149a.75.75 0 1 0-1.06-1.06z' />
  </svg>
);
